import * as ToastPrimitive from '@radix-ui/react-toast';
import { type ReactNode } from 'react';
import styles from './Toast.module.css';

export type ToastVariant = 'default' | 'success' | 'danger' | 'warning';

export type ToastProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: string;
  variant?: ToastVariant;
  duration?: number;
  action?: { label: string; onClick: () => void };
};

export function Toast({
  open,
  onOpenChange,
  title,
  variant = 'default',
  duration = 4000,
  action,
}: ToastProps) {
  return (
    <ToastPrimitive.Root
      open={open}
      onOpenChange={onOpenChange}
      duration={duration}
      className={styles.toast}
      data-variant={variant}
      role="status"
      aria-live="polite"
    >
      <ToastPrimitive.Title className={styles.title}>{title}</ToastPrimitive.Title>
      {action && (
        <ToastPrimitive.Action asChild altText={action.label}>
          <button className={styles.action} onClick={action.onClick}>{action.label}</button>
        </ToastPrimitive.Action>
      )}
      <ToastPrimitive.Close className={styles.close} aria-label="Закрыть">
        ×
      </ToastPrimitive.Close>
    </ToastPrimitive.Root>
  );
}

export function ToastProvider({ children }: { children: ReactNode }) {
  return <ToastPrimitive.Provider>{children}</ToastPrimitive.Provider>;
}

export function ToastViewport() {
  return <ToastPrimitive.Viewport className={styles.viewport} />;
}
